<template>
	<div class="popup_wrpr_inner" style="max-width: 600px;">
		<div class="popup">
			<div class="popup_header">
				<h3>Clone this product?</h3>
				<a @click="closePopup" class="close_popup_btn">
					<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
				</a>
			</div>
			<div class="content">
				<div>
					<input-field label="New product name" v-model="productNewName" required />
				</div>
			</div>
			<div class="popup_btn_wrpr mt_0 active">
				<v-button label="Clone" :disabled="!productNewName" @click="cloneProduct" :loading="saving"></v-button>
				<a @click="closePopup" class="btn brdr_btn">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import API from "@/api"
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";

export default {
	name: "CloneProductPopup",
	components: {VButton, InputField},
	props: ['product', 'isFplus', 'funnelId', 'stepId'],
	mixins: [API],
	data() {
		return {
			saving: false,
			deleteBtnState: false,
			checkboxModel1: false,
			checkboxModel2: false,
			checkboxModel3: false,
			progressNumber: 0,
			productNewName: '',
			productNewClone: {}
		}
	},
	methods: {
		closePopup() {
			this.$store.commit("closeCloneProductPopup");
		},
		async cloneProduct() {
			try {
				this.saving = true;
				if (!this.isFplus) {
					this.productNewClone.name = this.productNewName;
					delete this.productNewClone.id;

					let nameId = this.productNewClone.name.replace(/ /gi, "_").toUpperCase();
					let obId = nameId + '-OB';
					this.productNewClone.friendly_id = nameId;
					this.productNewClone.order_bump_id = obId;

					let result = await this.api.steps.cloneProduct(this.productNewClone);
					this.$store.dispatch('ADD_PRODUCT', result);
					this.$emit('done', result);
				} else {
					this.productNewClone.name = this.productNewName;
					delete this.productNewClone.id;
					let result = await this.api.wsteps.cloneProduct(this.funnelId, this.stepId, this.productNewClone);
					this.$store.dispatch('ADD_PRODUCT', result);
					this.$emit('done', result);
				}
				this.closePopup();
			} catch (e) {
				console.error("ERROR", e);
				this.$notify({
					type: 'error',
					group: 'main',
					title: 'Server error. Please try again later'
				});
			} finally {
				this.saving = false;
			}
		},
		nameInit() {
			this.productNewName = this.productNewClone.name + ' CLONE';
		}
	},
	created() {
		this.productNewClone = JSON.parse(JSON.stringify(this.product));
		this.nameInit();
	}
}
</script>

<style>
.brdr_box_w_checkbox h3 b {
	margin-right: 3px;
}
</style>
